import React, { Fragment } from 'react';

const LegacyWorkerCss = () => (
  <Fragment>
    <style jsx global>{`
      body {
        color: black;
      }

      /* ---------- BATCH PAGES -------------------------------------------- */

      @keyframes pulse {
        0% {
          transform: scale(1.05);
          opacity: 1;
        }
        50% {
          transform: scale(1);
          opacity: 0.8;
        }
        100% {
          transform: scale(1.05);
          opacity: 1;
        }
      }

      .batch__container {
        height: 100vh;
        width: 100vw;
        display: flex;
        align-items: center;
        justify-content: center;
      }

      .batch {
        width: 600px;
        padding: 40px;
        gmargin: 0 auto;
        background: rgba(0, 0, 0, 0.02);
        border: 1px solid rgba(0, 0, 0, 0.1);
        border-radius: 8px;
        box-shadow: 2px 2px 8px rgba(0, 0, 0, 0.05);

        text-align: center;
      }

      .batch__label {
        color: #505050;
        font-size: 24px;
        line-height: 1.5em;
        margin: 24px 0 48px;
      }

      .batch__label--detail {
        font-size: 18px;
      }

      .batch__icon {
        cursor: default;
        font-size: 72px;
        animation: pulse 3s;
        animation-timing-function: ease;
        animation-iteration-count: infinite;
        animation-play-state: running;
      }

      .batch__actions {
        margin-top: 24px;
      }

      .batch__action {
        margin: 0 12px;
      }
    `}</style>

    <style jsx global>{`
      /* ---------- SPLIT PANE --------------------------------------------- */

      .task__splitpane {
        flex-grow: 1;
        position: relative;
      }

      .SplitPane .Resizer {
        background: var(--bg-gray-light-1);
        z-index: 1;
        -moz-box-sizing: border-box;
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
        -moz-background-clip: padding;
        -webkit-background-clip: padding;
        background-clip: padding-box;
      }

      .SplitPane .Resizer:hover {
        -webkit-transition: all 1s ease;
        transition: all 1s ease;
      }

      .SplitPane .Resizer.vertical {
        width: 11px;
        margin: 0 -5px;
        border-left: 5px solid rgba(255, 255, 255, 0);
        border-right: 5px solid rgba(255, 255, 255, 0);
        cursor: col-resize;
      }

      .SplitPane .Resizer.vertical:hover {
        border-left: 5px solid rgba(0, 0, 0, 0.1);
        border-right: 5px solid rgba(0, 0, 0, 0.1);
      }

      .SplitPane .Pane {
        overflow: auto;
      }

      .SplitPane .Pane {
        overflow: auto;
      }

      .SplitPane .Pane::-webkit-scrollbar {
        -webkit-appearance: none;
        width: 10px;
        height: 10px;
      }

      .SplitPane .Pane::-webkit-scrollbar-corner,
      .SplitPane .Pane::-webkit-scrollbar-track-piece {
        background-color: transparent;
      }

      .SplitPane .Pane::-webkit-scrollbar-thumb {
        border-radius: 100px;
        height: 0px;
        background-color: #247eff;
      }

      .SplitPane .Pane::-webkit-scrollbar-track {
        background-color: transparent;
      }

      .SplitPane .Pane2 {
        min-width: 320px;
        max-width: 600px;

        overflow: visible;
      }

      .task__splitpane--fields .Pane2 {
        display: flex;
        flex-direction: column;
      }

      .task__splitpane--fields .Pane2 > div {
        flex-grow: 1;
        display: flex;
        flex-direction: column;
      }
    `}</style>

    <style jsx global>{`
      /* ---------- ANNOTATION --------------------------------------------- */

      .task.o__annotation {
        width: 100%;
        height: auto;
        display: flex;
        min-height: 100%;
        flex-direction: column;
        min-height: 0;
        padding-bottom: 0 !important;
      }
    `}</style>

    <style jsx global>{`
      #__next {
        height: 100%;
      }

      [data-reactroot],
      .nextjsWrapperDiv {
        height: 100%;
      }

      .tasks__container {
        flex-grow: 1;
        position: relative;
      }

      .task {
        min-height: 0;
        flex-grow: 1;
      }

      .scaler {
        background-color: #fff;
      }

      .scaler.tasks__container {
        display: flex;
        width: 100%;
        min-height: 100%;
        height: 100%;
      }

      .scaler.tasks__container.test {
        height: calc(100% - 40px);
        min-height: 0;
      }

      .standalone-practice .scaler.tasks__container.test {
        height: 100% !important;
      }

      .scaler.o__loading {
        justify-content: center;
        align-items: center;
      }

      .scaler .task__media-toolbar {
        display: flex;
        padding: 0 20px;
      }

      .scaler .task__media .instructions-container {
        margin: 0 -30px;
      }

      .scaler .task {
        width: 100%;
        box-sizing: border-box;
        display: flex;
        flex-direction: column;
        overflow: auto;
      }

      .scaler .task__media-instructions {
        display: flex;
        align-items: center;
      }

      .scaler .task__image__container {
        position: relative;
      }

      .scaler .completed--slide {
        transition: transform 0.4s ease-in-out;
        transition-property: transform, opacity;
        transform: translateX(-100%);
        opacity: 0;
      }

      .scaler .task__image {
        pointer-events: none;
      }

      .scaler .task__media-instructions {
        font-size: 12px;
        color: #333333;
        letter-spacing: 0px;
        font-weight: bold;
        text-transform: uppercase;
        flex: 1 0 19px;
      }

      .scaler .task__media {
        padding: 16px;
        flex: 1 1 auto;
        background-color: var(--color-RemoGray01);
      }

      .scaler .sp__1 {
        flex: 1 0 10px;
      }

      .scaler .status-bar {
        border: 1px solid #ccc;
        border-left-color: transparent;
        border-right-color: transparent;
        padding: 5px 10px;
        font-size: 14px;
        position: fixed;
        bottom: 67px;
        left: 0;
        right: 0;
        width: 100%;
        z-index: 5;
        display: flex;
        align-items: center;

        transition: 1s background-color ease-in-out;
        transition-property: background-color, border-color, color;

        background-color: #f3f3f3;
      }

      .scaler .fieldset {
        border: 0;
        padding: 0;
        margin: 0;
      }

      .scaler .fieldset label {
        margin-left: 5px;
        font-size: 13px;
      }

      .scaler .task__header {
        padding: 0 20px;
        font-size: 14px;
        color: #333;
        display: flex;
        flex: 0 0 40px;
        background: rgba(0, 0, 0, 0.05);
      }

      .scaler .task__header-side {
        display: flex;
        margin-top: auto;
        margin-bottom: auto;
      }

      .scaler .task__header-text {
        text-transform: uppercase;
        font-size: 12px;
        color: #333333;
        letter-spacing: 0px;
        font-weight: bold;
        margin-top: auto;
        margin-bottom: auto;
        text-transform: uppercase;
        flex-shrink: 0;
        flex-grow: 0;
      }

      .scaler .task .radio {
        margin-right: 15px;
      }

      .scaler .task .radio input {
        margin-right: 8px;
      }

      .scaler .task__header-text--right {
        margin-left: auto;
        display: flex;
      }

      .scaler .task__header-text--right small {
        margin-top: auto;
        margin-bottom: auto;
        margin-left: 5px;
        font-size: 12px;
      }

      .scaler .task__header .btn {
        height: 25px;
        margin-top: auto;
        margin-bottom: auto;
        margin-right: 5px;
      }

      .scaler .bounding__box-toolbar {
        display: none;
      }

      .scaler .attachment__group {
        display: flex;
      }

      .scaler .script__container {
        height: 100%;
        display: flex;
        flex-direction: column;
      }

      .scaler .script {
        flex: 1;
        display: flex;
        overflow: auto;
        white-space: pre-wrap;
      }

      .scaler .script * {
        line-height: 23px;
        flex-shrink: 0;
        flex-grow: 0;
        width: 100%;
        white-space: pre-line;
        flex-direction: column;
      }

      @media screen and (max-width: 1024px) {
        .scaler .examples__container {
          display: none;
        }
      }

      .completed--flash {
        animation: flash-completed-task 0.5s linear;
        animation-iteration-count: 2;
      }

      @keyframes flash-completed-task {
        0% {
          background-color: rgba(255, 255, 255, 0.5);
        }

        50% {
          background-color: rgba(0, 255, 7, 0.5);
        }

        100% {
          background-color: rgba(255, 255, 255, 0.5);
        }
      }
    `}</style>
  </Fragment>
);

export default LegacyWorkerCss;
